import { apiConstants, getWork } from './shared/config';
const req = require.context("./interventions/", true, /routes.js$/);
//código comentado pois estava duplicando os paths
// const modules = req.keys().map(req);
const moduleMap = {};

req.keys().map((key) => {
  const module = req(key);
  const type = req(key).type;

  if(moduleMap[type]) return;

   moduleMap[type] = module;
});

let routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import ( /* webpackChunkName: "gimgestao" */ './views/Home.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'home.title',
        }
    },
    {
        path: `/${apiConstants.code}/statuses`,
        component: () => import( /* webpackChunkName: "gimgestao-statuses" */ './views/status/StatusBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.global_statuses`,
                component: () => import( /* webpackChunkName: "gimgestao-statuses" */ './views/status/StatusList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'global_statuses.titles',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.global_statuses.create`,
                props: true,
                component: () => import( /* webpackChunkName: "gimgestao-statuses" */ './views/status/StatusDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'global_statuses.title',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.global_statuses.show`,
                props: true,
                component: () => import( /* webpackChunkName: "gimgestao-statuses" */ './views/status/StatusDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'global_statuses.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'global_statuses.titles',
        }
    },
    {
        path: `/${apiConstants.code}/types`,
        component: () => import( /* webpackChunkName: "gimgestao-types" */ './views/type/TypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.global_types`,
                component: () => import( /* webpackChunkName: "gimgestao-types" */ './views/type/TypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `global_types.titles`,
                }
            },
            {
                path: 'create',
                name: `${apiConstants.code}.global_types.create`,
                props: true,
                component: () => import( /* webpackChunkName: "gimgestao-types" */ './views/type/TypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'global_types.title',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.global_types.show`,
                props: true,
                component: () => import( /* webpackChunkName: "gimgestao-types" */ './views/type/TypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'global_types.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'global_types.title',
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackChunkName: "gimgestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'settings.titles',
        }
    },
    {
        path: `/{${apiConstants.code}}/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "gimgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "gimgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "gimgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "gimgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackChunkName: "gimgestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackChunkName: "gimgestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'layers.titles',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackChunkName: "gimgestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'layers.title',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackChunkName: "gimgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'layers.title',
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackChunkName: "gimgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'layers.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'layers.titles',
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackChunkName: "gimgestao-printvisibleemissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackChunkName: "gimgestao-printvisibleemissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
];
Object.keys(moduleMap).map((key) => {
    const work = getWork(key);
    if (work.active === true) {
        const route = moduleMap[key].routes;
        routes.push(route);
    }
})
//código comentado pois estava duplicando os paths
// modules.forEach(module => {
//     const work = getWork(module.type);
//     if (work.active === true) {
//         const route = module.routes;
//         routes.push(route);
//     }
// });

export default routes;
